"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    Object.defineProperty(f, 'path', {
        value: typeof path === 'string' ? path : file.name,
        writable: false,
        configurable: false
    });
    return f;
}
exports.toFileWithPath = toFileWithPath;
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (name && hasExtension && !file.type) {
        var ext = name.split('.')
            .pop();
        var type = exports.COMMON_MIME_TYPES.get(ext);
        if (type) {
            return clone(file, type);
        }
    }
    return clone(file);
}
function clone(file, type) {
    var data = file.slice();
    return new File([data], file.name, {
        lastModified: file.lastModified,
        type: type || file.type
    });
}
//# sourceMappingURL=file.js.map